import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Imperiality_table from "./imperiality_table/Imperiality_table";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Imperiality() {

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.imperiaity.List);
  
  return (
    <>
      <section className="Imperiality">
        <div className="back_div">
          <Common_Back_Btn backText="Imperiality" />
        </div>

        <div className="imperiality_table_div">
          { haveReadPermission && <Imperiality_table />}
        </div>
      </section>
    </>
  );
}

export default Imperiality;
